export default __webpack_public_path__ + "picklink.e818114.png";